var React = require('react');

function Timeline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.62,1.2a7.63,7.63,0,1,0,7.63,7.63A7.63,7.63,0,0,0,8.62,1.2Zm.6,8.63H4.38v-2H8L9.78,4.39l1.78.92Z"}));
}

Timeline.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 18 18"};

module.exports = Timeline;

Timeline.default = Timeline;
